import { render, staticRenderFns } from "./scorePage.vue?vue&type=template&id=1b803f1f&scoped=true"
import script from "./scorePage.vue?vue&type=script&lang=js"
export * from "./scorePage.vue?vue&type=script&lang=js"
import style0 from "./scorePage.vue?vue&type=style&index=0&id=1b803f1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b803f1f",
  null
  
)

export default component.exports